import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { axios } from '../contexts/AuthContext';

export default function BoothVoters() {
  const { boothNumber } = useParams();
  const navigate = useNavigate();
  const [voters, setVoters] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchVoters = async (p = 1) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.get(`/voters/booth/${boothNumber}`, {
        params: { page: p, limit: 50 }
      });
      setVoters(data.voters || []);
      setTotal(data.total || 0);
      setPages(data.pages || 1);
      setPage(p);
    } catch(e) {
      console.error('Booth voters error:', e);
      setError(e.response?.data?.error || e.message || 'Failed to load voters');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (boothNumber) fetchVoters(1);
  }, [boothNumber]);

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(160deg,#FFF4ED,#FFF8F0)', fontFamily:"'Outfit',sans-serif" }}>

      {/* Header */}
      <div className="app-header">
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <button className="back-btn" onClick={() => navigate('/booths')}>←</button>
          <div>
            <div style={{ fontFamily:"'Baloo 2',sans-serif", fontWeight:700, fontSize:'1.1rem', color:'white' }}>
              🏫 Booth {boothNumber}
            </div>
            <div style={{ fontSize:'0.7rem', opacity:.85, color:'white' }}>
              {total.toLocaleString()} voters
            </div>
          </div>
        </div>
        <div style={{ background:'rgba(255,255,255,0.2)', border:'1px solid rgba(255,255,255,0.35)', padding:'5px 14px', borderRadius:99, fontSize:'0.8rem', fontWeight:700, color:'white' }}>
          {total} Total
        </div>
      </div>

      {/* Column Headers */}
      <div style={{ display:'grid', gridTemplateColumns:'70px 1fr 80px', gap:8, padding:'10px 16px', background:'rgba(255,107,0,0.08)', fontSize:'0.72rem', fontWeight:700, color:'#BF360C', borderBottom:'2px solid rgba(255,107,0,0.12)', position:'sticky', top:60, zIndex:10 }}>
        <span>Booth/S.No</span>
        <span>Name / Relative</span>
        <span style={{textAlign:'right'}}>Sex/Age</span>
      </div>

      {/* Content */}
      <div style={{ padding:'8px 16px 80px' }}>
        {loading ? (
          <div className="loader"><div className="spinner"/></div>
        ) : error ? (
          <div style={{ textAlign:'center', padding:'48px 20px', color:'#C62828' }}>
            <div style={{ fontSize:'2.5rem', marginBottom:12 }}>⚠️</div>
            <div style={{ fontWeight:700, marginBottom:8 }}>Error loading voters</div>
            <div style={{ fontSize:'0.82rem', background:'#FFEBEE', padding:'10px 16px', borderRadius:10, color:'#B71C1C' }}>{error}</div>
            <button onClick={()=>fetchVoters(1)} style={{ marginTop:16, padding:'10px 20px', background:'#E55100', color:'white', border:'none', borderRadius:10, cursor:'pointer', fontWeight:700 }}>🔄 Retry</button>
          </div>
        ) : voters.length === 0 ? (
          <div style={{ textAlign:'center', padding:'48px 20px', color:'#9E6040' }}>
            <div style={{ fontSize:'2.5rem', marginBottom:12 }}>📭</div>
            <div style={{ fontWeight:700 }}>No voters found for Booth {boothNumber}</div>
          </div>
        ) : (
          <>
            {voters.map(v => (
              <div
                key={v.id}
                className="voter-list-item"
                onClick={() => navigate(`/voter/${v.id}`)}
              >
                {/* Booth / Serial */}
                <div style={{ textAlign:'center', minWidth:52, flexShrink:0 }}>
                  <div style={{ fontWeight:800, fontSize:'0.9rem', color:'#E55100' }}>{v.booth_number}</div>
                  <div style={{ fontSize:'0.72rem', color:'#9E6040', marginTop:2 }}>{v.serial_number || '—'}</div>
                </div>

                {/* Name / Relative */}
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontWeight:700, fontSize:'0.9rem', color:'#1A0A00', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                    {v.name}
                  </div>
                  <div style={{ fontSize:'0.75rem', color:'#9E6040', marginTop:2, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                    {v.relation_name || '—'}
                  </div>
                </div>

                {/* Gender / Age / Mobile */}
                <div style={{ textAlign:'right', flexShrink:0 }}>
                  <div className={`badge badge-${v.gender === 'M' ? 'm' : v.gender === 'F' ? 'f' : 'none'}`}>
                    {v.gender}/{v.age}
                  </div>
                  {v.mobile && (
                    <div style={{ fontSize:'0.68rem', color:'#C4A090', marginTop:3 }}>
                      ••{String(v.mobile).slice(-4)}
                    </div>
                  )}
                </div>
              </div>
            ))}

            {/* Pagination */}
            {pages > 1 && (
              <div className="pagination">
                <button className="page-btn" onClick={() => fetchVoters(page - 1)} disabled={page === 1}>‹</button>
                <span style={{ fontSize:'0.85rem', color:'#9E6040', fontWeight:600 }}>
                  Page {page} of {pages}
                </span>
                <button className="page-btn" onClick={() => fetchVoters(page + 1)} disabled={page === pages}>›</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}